<template>
  <div class="monitor-tree-node" :class="{ 'monitor-tree-node--open': isOpen }">
    <button type="button" class="monitor-tree-node__header" :style="{ paddingLeft: (10 + depth * 22) + 'px' }" @click="$emit('toggle', node.path)">
      <AppIcon class="monitor-tree-node__caret" :name="isOpen ? 'expand_more' : 'chevron_right'" />
      <span class="monitor-tree-node__icon" :class="{ 'monitor-tree-node__icon--image': node.image }">
        <img v-if="node.image" :src="node.image" alt="" />
        <AppIcon v-else :name="node.level.icon" />
      </span>
      <span class="monitor-tree-node__name" :class="{ 'text-muted': node.empty }">{{node.name}}</span>
      <span class="monitor-tree-node__level">{{node.level.label}}</span>
      <b-badge variant="light" class="monitor-tree-node__count">{{node.items.length}}</b-badge>
      <span class="monitor-tree-node__health"><slot name="health" :items="node.items" :summary="summary" /></span>
    </button>

    <div v-if="isOpen" class="monitor-tree-node__body" :style="{ '--tree-guide': (20 + depth * 22) + 'px' }">
      <template v-if="node.children.length">
        <MonitorTreeNode v-for="child in node.children" :key="child.path"
                         :node="child" :depth="depth + 1" :expanded="expanded" :summarize="summarize"
                         @toggle="$emit('toggle', $event)">
          <template v-for="(_, slot) in $scopedSlots" v-slot:[slot]="scope"><slot :name="slot" v-bind="scope" /></template>
        </MonitorTreeNode>
      </template>
      <div v-else class="monitor-tree-node__leaf" :style="{ marginLeft: (20 + depth * 22) + 'px' }">
        <slot name="leaf" :items="node.items" />
      </div>
    </div>
  </div>
</template>

<script>
  // nodo del árbol de agrupamiento (recursivo): cabecera desplegable y, abajo,
  // sus subgrupos o, en el último nivel, la tabla de registros (slot leaf)
  export default {
    name: 'MonitorTreeNode',
    props: {
      node: { type: Object, required: true },
      depth: { type: Number, default: 0 },
      expanded: { type: Object, required: true }, // {path: true}
      summarize: { type: Function, default: null }, // items -> resumen del grupo (slot health)
    },
    computed: {
      summary() {
        return this.summarize ? this.summarize(this.node.items) : null
      },
      isOpen() {
        return !!this.expanded[this.node.path]
      },
    },
  }
</script>

<style scoped>
  .monitor-tree-node__header {
    display: flex;
    align-items: center;
    gap: 6px;
    width: 100%;
    padding-top: 7px;
    padding-bottom: 7px;
    padding-right: 12px;
    border: none;
    border-bottom: 1px solid var(--app-color-border);
    background: transparent;
    text-align: left;
    cursor: pointer;
  }

  .monitor-tree-node__header:hover {
    background: var(--app-color-surface-subtle);
  }

  .monitor-tree-node__caret {
    color: var(--app-color-text-muted);
  }

  .monitor-tree-node__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 6px;
    background: var(--app-color-primary-soft);
    color: var(--app-color-primary-active);
    font-size: 15px;
  }

  .monitor-tree-node__icon--image {
    background: var(--app-color-surface);
    border: 1px solid var(--app-color-border);
  }

  .monitor-tree-node__icon img {
    width: 15px;
    height: 15px;
  }

  .monitor-tree-node__name {
    font-weight: 600;
  }

  .monitor-tree-node__level {
    color: var(--app-color-text-muted);
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: .03em;
  }

  .monitor-tree-node__health {
    margin-left: auto;
    font-size: 13px;
  }

  /* línea guía vertical que une el nodo con sus hijos */
  .monitor-tree-node__body {
    position: relative;
  }

  .monitor-tree-node__body::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 8px;
    left: var(--tree-guide);
    border-left: 1px dashed var(--app-color-border-strong);
    pointer-events: none;
  }

  .monitor-tree-node__leaf {
    padding: 4px 0 10px 12px;
    border-bottom: 1px solid var(--app-color-border);
  }
</style>
